import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import {
  SmMessageRoomResponse,
  SmNewLinkRequest,
  SmOtpSendRequest,
  SmOtpVerifyRequest,
  SmOtpVerifyResponse,
  SmReplyRequest,
  SmResolveRequest,
  SmResolveResponse,
} from "./secure-message.model";

const BASE = "api/secure-messages";

/** AllowAnonymous secure messaging APIs (practice portal). */
@Injectable({ providedIn: "root" })
export class SecureMessageService {
  constructor(private http: HttpClient) {}

  private url(action: string): string {
    return `${environment.apiBaseUrl}/${BASE}/${action}`;
  }

  resolve(body: SmResolveRequest): Observable<SmResolveResponse> {
    return this.http.post<SmResolveResponse>(this.url("resolve"), body);
  }

  requestNewLink(body: SmNewLinkRequest): Observable<SmResolveResponse> {
    return this.http.post<SmResolveResponse>(this.url("new-link"), body);
  }

  sendOtp(body: SmOtpSendRequest): Observable<{ ok: boolean }> {
    return this.http.post<{ ok: boolean }>(this.url("otp/send"), body);
  }

  verifyOtp(body: SmOtpVerifyRequest): Observable<SmOtpVerifyResponse> {
    return this.http.post<SmOtpVerifyResponse>(this.url("otp/verify"), body);
  }

  message(sessionToken: string): Observable<SmMessageRoomResponse> {
    return this.http.post<SmMessageRoomResponse>(this.url("message"), { session_token: sessionToken });
  }

  /** Returns the refreshed thread room (all messages). */
  reply(body: SmReplyRequest): Observable<SmMessageRoomResponse> {
    return this.http.post<SmMessageRoomResponse>(this.url("reply"), body);
  }
}
